/**
* CLASS WindowUbicaciones
*
* Contiene el componente que lista las ubicaciones de un departamento
*
* @author Hector Morales <hector.morales@ikarosofttechnology.com>
*/

import React, { Component } from 'react';
import DataGrid from '../../data_grid/DataGrid';

class WindowUbicaciones extends Component {  
  	render() { 
        let sqlParams = { 
                            fieldSearch : [
                                'nombre',                                
                            ], 
                            sqlWhere : [
                                ' AND T1.id_departamento = '+this.props.params.idDepartamento
                            ],                                                      
                            filtroFechas : "false",                                                                           
                        };                    
  	  	return (
            <div style={{height: 'calc(100% - 30px)'}}>                
                <div style={{position:"relative",height:"100%",overflow:"auto"}}>  
                    <DataGrid titulo='Ubicaciones' 
                              funcionClick={this.props.funcionClick}   
                              parametro={this.props.parametro} 
                              colsData={[ 
                                            {
                                                type  : 'bd',
                                                label : 'Nombre',
                                                field : 'nombre'
                                            }                                        
                                        ]}
                              sqlParams = { sqlParams }                       
                              automatica="true"
                              botonNuevo="true"
                              formFields={[
                                            {
                                                label : 'Nombre *',
                                                field : 'nombre',
                                                type  : 'text',
                                                validation : 'texto_mayusculas',
                                                required : 'true',
                                                longitud : 45,
                                                tooltip : 'Ingrese el nombre de la ubicacion'
                                            },
                                            {
                                                label : '',
                                                field : 'id_departamento',
                                                type  : 'hidden',
                                                validation : '',
                                                value : this.props.params.idDepartamento,
                                                required : 'true'                                        
                                            },                                                                          
                                        ]}                     
                              apiField={'departamentos_ubicaciones'}
                              mainContainer='WindowUbicaciones'/> 
                </div>
            </div>                				
			  );
  	}
}

export default WindowUbicaciones